import React, { useEffect, useRef } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { StoreManagerLink } from "../../routes/routes";
import Navbar from "../Home/navbar/Navbar";

const SellerDashboard = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const scrollToTop = useRef(null);

  useEffect(() => {
    scrollToTop.current.scrollIntoView({ behavior: "smooth" });
  }, []);


  useEffect(() => {
    if (pathname === "/SellerDashboard" || pathname === "/SellerDashboard/") {
      navigate("/SellerDashboard/SellerDashboard");
    }
  }, [pathname, navigate]);

  return (
    <div ref={scrollToTop}>
      <Navbar />
      <div className="w-full h-[1000px] flex items-center justify-center" >
        <div className="w-[1240px] h-[935px] bg-[#FFF9F2] rounded-[10px] flex flex-row shadow-[0_0px_0px_1px_rgba(0,0,0,0.07)]">
          <div className="w-[226px] h-[935px] bg-black text-white rounded-l-[10px] flex flex-col items-center justify-start gap-y-[47px]">
            <h2 className="w-[165px] h-[24px] text-white font-semibold text-[16px] text-start mt-[29px]">
              Store Manager
            </h2>
            <div className="flex flex-col gap-y-[3px] w-[226px] h-[635px] overflow-y-auto">
              {StoreManagerLink.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={
                      "flex space-x-3 rounded" +
                      (pathname.includes(item.url)
                        ? " bg-[#3B4248] text-white font-semibold space-x-2 text-[14px]"
                        : "")
                    }
                    onClick={() => navigate(item.url)}
                  >
                    <div className="flex w-[226px] h-[46px] items-center justify-start">
                      <button className="flex items-center justify-start select-none w-[226px] h-[46px]">
                        <hr
                          className={
                            pathname.includes(item.url)
                              ? "bg-[#F26422] w-[4px] h-[46px] rounded-full"
                              : ""
                          }
                        />
                        <img
                          className="w-[20px] h-[20px] rounded-full ml-[23px] mr-[15px]"
                          src={item.img}
                          alt="itemImg"
                        />
                        <div className="flex items-center justify-between w-[150px] text-[14px] font-regular">
                          {item.type}
                        </div>
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default SellerDashboard;
